import BenchSeatPage from './BenchSeatPage';

const SMALL_SQUARE_IMG = 'https://customer-assets.emergentagent.com/job_613a98c3-3eae-4e44-a2f7-064499799113/artifacts/xj9u57sc_small-rectangle-bench-seat-cushion.png';

const GALLERY_IMAGES = [
  { src: 'https://customer-assets.emergentagent.com/job_613a98c3-3eae-4e44-a2f7-064499799113/artifacts/q8uk9vdb_rectangle-bench-seat-cushion.png', alt: 'Square Seat Cushion' },
  { src: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80', alt: 'Modern green sofa' },
  { src: 'https://images.unsplash.com/photo-1721322800607-8c38375eef04?w=800&q=80', alt: 'Living room with sofa' },
  { src: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=800&q=80', alt: 'Contemporary living space' },
];

// Custom Cover & Foam Insert imagery — keeps the small square render as the
// first image on Step 1, separate from the customizer's main gallery slides.
const PRODUCT_IMAGES = {
  cover_and_foam: [
    { src: SMALL_SQUARE_IMG, alt: 'Square Seat Cushion — Cover & Foam Insert' },
    GALLERY_IMAGES[1],
  ],
  cover_only: [GALLERY_IMAGES[1], GALLERY_IMAGES[2]],
  foam_only: [
    { src: '/foam-texture.png', alt: 'High-density foam interior' },
    { src: '/product-type-foam-only.png', alt: 'Custom-cut foam insert' },
  ],
};

const SquareBenchSeatPage = () => (
  <BenchSeatPage
    cushionId="square-bench-seat-cushion"
    galleryImages={GALLERY_IMAGES}
    productImages={PRODUCT_IMAGES}
    defaultPreviewColor={null}
    defaultDimensions={{ length: 60, width: 60, thickness: 10 }}
    cameraDefault={{
      // Captured desktop reset view (≈ 142cm distance, ~50° polar, 180° azimuth)
      position: { x: 0.0014, y: 0.6984, z: -0.8993 },
      target: { x: 0.0011, y: -0.0265, z: -0.0219 },
    }}
    toastName="Square Seat Cushion"
    productName="Square Seat Cushion"
    productDescription="A timeless square cushion tailored for bench seats, window seats, and built-in seating. Made to your exact measurements with premium foam and your choice of Warwick upholstery fabric."
    pageTestId="square-bench-seat-page"
  />
);

export default SquareBenchSeatPage;
